import React from 'react'
import { Typography } from 'antd'
import styled from '@emotion/styled'
import { Delivery } from 'components/Orders/Info/type'

interface DeliveryHeaderProps {
  delivery: Delivery
}

const { Text } = Typography

const DeliveryHeader = ({ delivery }: DeliveryHeaderProps) => {
  const { job_id } = delivery || {}
  return (
    <>
      <JobLabel className='_mr-2'>Job ID:</JobLabel>
      <Text strong>{job_id || '-'}</Text>
    </>
  )
}

const JobLabel = styled.span`
  color: #77778e;
`

export default DeliveryHeader
